import { createEventCreator as event } from './ga';
import { BUTTON_SELECTED, LINK_SELECTED } from 'config/constants/gaCommonActions';

export const manageBookingReturnLinkTopSelected = event(() => ({
  category: 'Manage Booking Return Link',
  action: 'Top Link Selected',
}));

export const manageBookingReturnLinkBottomSelected = event(() => ({
  category: 'Manage Booking Return Link',
  action: 'Bottom Link Selected',
}));

export const returnToManageYourBookingLinkSelected = event(() => ({
  category: 'Return To Manage Your Booking Link',
  action: LINK_SELECTED,
}));

export const confirmButtonSelected = event(() => ({
  category: 'Confirm Button',
  action: `Refund ${BUTTON_SELECTED}`,
}));

export const luxuryOffersLinkSelected = event(() => ({
  category: 'Luxury Offers Link',
  action: LINK_SELECTED,
}));

export const refundOptionsToggle = event(() => ({
  category: 'Refund Options Toggle',
  action: 'Refund Credit Card Selected',
}));
